import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const QQShare = Loadable({
    loader: () => import(/* webpackChunkName: "QQShare" */ './qqShare'),
    loading: () => <div />,
});
